import { useSnapshot } from 'valtio';
import { techniciansState } from './state';

export function useTechnicians() {
  const {
    technicians,
    technicianById,
    techniciansLoading,
    techniciansLoadFailed,
    techniciansHasPartialError,
  } = useSnapshot(techniciansState);
  return {
    technicians,
    technicianById,
    isLoading: techniciansLoading,
    loadFailed: techniciansLoadFailed,
    hasPartialError: techniciansHasPartialError,
  };
}
